import { Control, ControlType, KngFilterState, Option, Section } from 'kinetic-angular';
import { SharedFactoryDataService } from './shared-factory-data.service';

export class SharedFilterFactory 
{
	public static buildFilterState(sections: Section[]): KngFilterState 
	{
		return {
			filterData: {
				heading: { label: '' },
				sections: sections,
				ctaList: [
					{
						id: '327147f4-c044-4799-8a5a-d075c619e41c',
						label: '',
						className: 'light',
						disabled: true
					},
					{
						id: '7eeaa3f0-b4f6-4142-8086-361298d75686',
						label: '',
						className: 'dark',
						disabled: false
					}
				]
			},
			hidden: true
		};
	}
	public static buildDateRangeSection(options: Option[] = []): Section 
	{
		return {
			label: '',
			controls: [
				new Control({
					id: '9e42775d-7ea0-4dc0-ab16-7fb9d013ac31',
					label: '',
					type: ControlType.radio,
					inputPlaceholderText: '',
					inputIcon: '',
					options: options,
					value: ''
				})
			],
			accordionCollapsedIcon: SharedFactoryDataService.getAccordionCollapsedIcon(),
			accordionExpandedIcon: SharedFactoryDataService.getAccordionExpandedIcon(),
			searchIcon: SharedFactoryDataService.getSearchIcon(),
			crossIcon: SharedFactoryDataService.getSearchCrossIcon(),
			collapsed: true
		};
	}
	public static buildLocationSection(isCollapsed: boolean = false): Section 
	{
		return {
			label: '',
			controls: SharedFactoryDataService.getInputControlTypeInputOne(),
			accordionCollapsedIcon: SharedFactoryDataService.getAccordionCollapsedIcon(),
			accordionExpandedIcon: SharedFactoryDataService.getAccordionExpandedIcon(),
			searchIcon: SharedFactoryDataService.getSearchIcon(),
			crossIcon: SharedFactoryDataService.getSearchCrossIcon(),
			collapsed: isCollapsed,
			isShowMorePresent: true,
			showMoreShowLess: {
				isDisabled: false,
				showLessText: '',
				showMoreText: '',
				isShowMoreClicked: false
			}
		};
	}
	public static buildDivisionOrGroupSection(isCollapsed: boolean = false): Section 
	{
		return {
			label: '',
			controls: [],
			accordionCollapsedIcon: SharedFactoryDataService.getAccordionCollapsedIcon(),
			accordionExpandedIcon: SharedFactoryDataService.getAccordionExpandedIcon(),
			searchIcon: SharedFactoryDataService.getSearchIcon(),
			crossIcon: SharedFactoryDataService.getSearchCrossIcon(),
			collapsed: isCollapsed,
			isShowMorePresent: true,
			showMoreShowLess: {
				isDisabled: false,
				showLessText: '',
				showMoreText: '',
				isShowMoreClicked: false
			}
		};
	}
}
